import { useContext, useEffect, useRef, useState } from "react";
import { Button, ButtonGroup, Card, Dropdown, Form, Icon, Label, Menu, Modal } from "semantic-ui-react";
import { dialogControl } from "../../controls/dialog-control";
import { ModalControlData, useModalControl } from "../../hooks/commonHooks";
import { hostUrl, httpRequest, restRequest } from "../../http";
import { DataFile } from "../../models/common_model";
import { notificationControl } from "../../controls/notification-control";
import { LanguageContext } from "../../context";

function isImage(name: string) {
    for (const jExt of ['jpg', 'jpeg', 'png', 'gif']) {
        if (name.toLocaleLowerCase().endsWith('.' + jExt)) {
            return true;
        }
    }

    return false;
}

interface FileLink {
    url: string,
    name: string
}

export function FilesInput(props: { name: string, value: DataFile[], containerType: number, containerId: number, onChange: (event: any, data: { name: string, value: DataFile[] }) => void }) {
    const { name, value, containerType, containerId, onChange } = props;
    const fileInputRef = useRef<HTMLInputElement>(null);
    const [loading, setLoading] = useState(false);
    const viewModalControl = useModalControl<{ id?: number, url?: string }>({});
    const linkModalControl = useModalControl<FileLink>({ name: '', url: '' });
    const [t] = useContext(LanguageContext);


    return <div style={{ position: 'relative', width: '100%' }}>
        <Label.Group style={{ float: 'left' }}>
            {(value || []).map(file => {

                return <Label key={file.id} image
                    onClick={e => {
                        e.stopPropagation();
                        e.preventDefault();

                        if (isImage(file.name)) {
                            viewModalControl.data = file;
                            viewModalControl.setOpen(true);
                            return;
                        }

                        if (file.url) {
                            window.open(file.url, '_blank');
                            return;
                        }

                        window.open(hostUrl('files/attachment/' + file.id), '_blank');
                    }}
                    style={{ cursor: 'pointer', textDecoration: file.deleted ? 'line-through' : '' }}>{file.name} {!file.deleted ? <Icon name='delete' onClick={(e: any) => {
                        e.stopPropagation();
                        e.preventDefault();

                        onChange({ target: fileInputRef.current }, { name, value: value.map(v => v.id !== file.id ? v : { ...v, deleted: true }) });
                    }} /> : <Icon name="refresh" onClick={(e: any) => {
                        e.stopPropagation();
                        e.preventDefault();

                        onChange({ target: fileInputRef.current }, { name, value: value.map(v => v.id !== file.id ? v : { ...v, deleted: false }) })
                    }}></Icon>}
                </Label>;
            })}
        </Label.Group>
        <Dropdown
            className='button icon left floated mini blue'
            floating
            icon="add"
        >
            <Dropdown.Menu>
                <Menu.Item onClick={e => {
                    e.preventDefault();
                    fileInputRef.current?.click();
                }}>
                    {t("Local File")}
                </Menu.Item>
                <Menu.Item onClick={e => {
                    e.preventDefault();
                    linkModalControl.start({ name: '', url: '' }, (data) => {
                        setLoading(true);
                        restRequest<DataFile[]>(`files/upload/${containerType}/${containerId}`, data, 'post').then(result => {
                            onChange({ target: fileInputRef.current! }, { name, value: [...value, ...result] });
                        }).finally(() => setLoading(false));

                        return true;
                    });
                }}>
                    {t("Link")}
                </Menu.Item>
            </Dropdown.Menu>
        </Dropdown>

        <input name={name} ref={fileInputRef} type="file" multiple style={{ display: 'none' }} onChange={e => {
            if (fileInputRef.current?.files && fileInputRef.current?.files?.length > 0) {
                setLoading(true);
                const postData = new FormData();
                if (fileInputRef.current?.files) {
                    for (let i = 0; i < fileInputRef.current.files.length; i++) {
                        postData.append('file_' + i, fileInputRef.current.files[i]);
                    }
                }

                httpRequest<DataFile[]>(`files/upload/${containerType}/${containerId}`, postData, 'post', {}).then(result => {
                    fileInputRef.current!.value = '';
                    onChange({ target: fileInputRef.current! }, { name, value: [...value, ...result] });
                }).finally(() => setLoading(false));
            }
        }}></input>

        <Modal {...viewModalControl.props} closeIcon size="fullscreen">
            <Modal.Content>
                <img src={viewModalControl.data.url || hostUrl('files/' + viewModalControl.data.id)} />
            </Modal.Content>
        </Modal>

        <LinkEditor modalControl={linkModalControl} />
    </div>
}


function LinkEditor(props: { modalControl: ModalControlData<FileLink> }) {
    const { modalControl } = props;
    const [link, setLink] = useState<FileLink>({ url: '', name: '' });
    useEffect(() => {
        setLink(modalControl.data || {});
    }, [modalControl.data]);

    return <Modal {...modalControl.props}>
        <Modal.Content>
            <Form onSubmit={e => {
                e.preventDefault();
                e.stopPropagation();
                if (e.currentTarget.checkValidity()) {
                    modalControl.finish(link);
                }
            }}>
                <Form.Input required label="Link" type="url" name="link" placeholder="Copy a Link" value={link.url || ''} onChange={(e, d) => setLink(l => ({ ...l, url: d.value }))} onBlur={() => {
                    setLink(l => {
                        const url = l.url.trim();
                        const data = { ...l, url };
                        if (url && !data.name && !data.name.trim()) {
                            data.name = url.split('/').pop() || '';
                        }

                        return data;
                    });
                }} />

                <Form.Input required label="Name" placeholder="Display Text" name="name" value={link.name || ''} onChange={(e, d) => {
                    setLink(l => ({ ...l, name: d.value }));
                }} onBlur={() => {
                    setLink(l => ({ ...l, name: l.name.trim() }))
                }} />

                <Button primary type="submit">Add</Button>
                <Button secondary as="a" onClick={e => modalControl.setOpen(false)}>Cancel</Button>
            </Form>
        </Modal.Content>
    </Modal >
}